import React, { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Grid from "@mui/material/Grid";

import DrivingTogether_Stretch from "@/_images/DrivingTogether_Stretch.png";
import DrivingTogether_Wide from "@/_images/DrivingTogether_Wide.png";
import HandingKeys_Stretch from "@/_images/HandingKeys_Stretch.png";
import HandingKeys_Wide from "@/_images/ISA_Wide3.png";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import ComputerOutlinedIcon from "@mui/icons-material/ComputerOutlined";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import PermPhoneMsgOutlinedIcon from "@mui/icons-material/PermPhoneMsgOutlined";
import Link from "@mui/material/Link";
import HistoryIcon from "@mui/icons-material/History";
import { useTranslation } from "react-i18next";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import PropTypes from "prop-types";
import DoneSharpIcon from '@mui/icons-material/DoneSharp';

const ReadySpeed = ({handleUpdate}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { t } = useTranslation();
  const [currentScreen, setCurrentScreen] = useState("ready");
  const handleScheduleLater = () => {
    setCurrentScreen("7.5.2");
    let data = {
      subStep: "7.5.2",
    }
    handleUpdate("Ready",data)
  };

  const handleSchedulNow = () => {
    handleUpdate("Ready")
  };

  if (currentScreen === "7.5.2") {
    return (
      <Grid
        sx={{
          // py: { xs: 4, md: 8 },
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
        }}
      >
        <Box
          component="img"
          src={isMobile ? HandingKeys_Wide : HandingKeys_Stretch}
          alt="Smiling driver"
          sx={{
            width: "100%",
            mb: { xs: 3, md: 5 },
            objectFit: "cover",
          }}
        />

        <Box
          sx={{
            textAlign: "left",
            maxWidth: 700,
            px: { xs: 4, md: 4 },
          }}
        > 
          <Typography
            variant={isMobile ? "h5" : "h4"}
            fontWeight={700}
            mb={2}
            color="text.primary"
          >
            {t("speed.takeYourTime")}
          </Typography>

          <Typography
            variant="body1"
            color="text.secondary"
            mb={1.5}
            sx={{
              lineHeight: 1.6,
              display: "flex",
              alignItems: "start",
              gap: 1,
              fontWeight: 500,
            }}
          >
            <DoneOutlinedIcon sx={{ color: "#76bc21" }} />
            <span>{t("speed.readyDescription2")}</span>
          </Typography>

          <Typography
            variant="body1"
            color="text.secondary"
            sx={{
              lineHeight: 1.6,
              display: "flex",
              alignItems: "start",
              gap: 1,
              fontWeight: 500,
            }}
          >
            <PermPhoneMsgOutlinedIcon sx={{ color: "#76bc21" }} />
            {isMobile ? (
              <span
                dangerouslySetInnerHTML={{
                  __html: t("speed.readyDescription1Mobile", {
                    anyTime: "<strong style='color:#1C355E'><i>any time</i></strong>"
                  }),
                }}
              />
            ) : (
              t("speed.readyDescription1")
            )}
          </Typography>
        </Box>
        <Grid
          container
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Link
            underline="none"
            href="https://www.lifesaferisa.com"
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
              paddingLeft: "20px",
              paddingRight: "20px",
              paddingTop: "25px",
            }}
          >
            <HistoryIcon
              style={{
                fontWeight: "bold",
              }}
            />
            <Typography
              style={{
                textTransform: "uppercase",
              }}
            >
              {t("speed.backTo")} {t("speed.lifesaferISA")}
            </Typography>
          </Link>
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid
      sx={{
        // py: { xs: 4, md: 8 },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
        width: "100%",
      }}
      style={{ minHeight: 'calc(100vh - 70px)' }}
    >
      <Box
        component="img"
        src={isMobile ? DrivingTogether_Wide : DrivingTogether_Stretch}
        alt="Smiling driver"
        sx={{
          width: "100%",
          mb: { xs: 3, md: 5 },
          objectFit: "cover",
        }}
      />

      <Box
        sx={{
          textAlign: "left",
          maxWidth: 700,
          px: { xs: 4, md: 4 },
        }}
      >
        <Grid>
          <Typography
            variant={isMobile ? "h5" : "h4"}
            fontWeight={700}
            mb={2}
            color="text.primary"
          >
            {isMobile ? t("speed.readyNextStep") : t("speed.allSet")}
          </Typography>

          <Typography
            variant="body1"
            color="text.secondary"
            mb={1.5}
            sx={{
              lineHeight: 1.6,
              display: "flex",
              alignItems: "start",
              gap: 1,
              fontWeight: 500,
            }}
          >
             {!isMobile && 
            <span style={{ position:"relative" }}>
                <ComputerOutlinedIcon sx={{ color: "#76bc21" }} />
                    <DoneSharpIcon sx={{ position:"absolute", left:"5.9px", top:"5px", width:"12px", height:"12px",color: "#76bc21" }}/>
            </span>
            }
            <span>{t("speed.readyDescription3")}</span>
          </Typography>

          <Typography
            variant="body1"
            color="text.secondary"
            sx={{
              lineHeight: 1.6,
              display: "flex",
              alignItems: "start",
              gap: 1,
              fontWeight: 500,
            }}
          >
            {!isMobile && (
              <CalendarMonthOutlinedIcon sx={{ color: "#76bc21" }} />
            )}
            <span>{t("speed.readyDescription4")}</span>
          </Typography>
        </Grid>
      </Box>

      <Grid
        spacing={4}
        sx={{
          display: "flex",
          maxWidth: 700,
          justifyContent: "space-between",
          alignItems: "center",
          px: { xs: 1, md: 4 },
          gap: { xs: 0.5, md: 0 },
          width: "100%",
          mt: { xs: "auto", md: 4 },
        }}
      >
        <Button
          onClick={handleScheduleLater}
          variant="text"
          sx={{
            color: "#1C355E",
            textTransform: "uppercase",
            width: { xs: "100%", md: "auto" },
            order: { xs: 0, md: 1 },
          }}
        >
          {isMobile ? t("speed.scheduleLater") : t("speed.saveScheduleLater")}
        </Button>

        <Button
          variant="contained"
          size="medium"
          onClick={handleSchedulNow}
          sx={{
            backgroundColor: "#76bc21",
            color: "#1c355e",
            fontWeight: "bold",
            width: { xs: "100%", md: 300 },
            order: { xs: 1, md: 0 },
            "&:hover": {
              backgroundColor: "#6aa91d",
            },
          }}
          endIcon={
            <span style={{ display: "flex", fontWeight: "bold" }}>
              <ArrowForwardIcon />
            </span>
          }
        >
          {t("steps.scheduleNow")}
        </Button>
      </Grid>
    </Grid>
  );
};
ReadySpeed.propTypes = {
handleUpdate:PropTypes.func,
};

export default ReadySpeed;
